interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <main className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 md:px-8 z-10" style={{ paddingTop: 'var(--nav-height)' }}>
      {children}
    </main>
  );
};
